import moment from 'moment';

import {PostTypes} from '../constants';

interface IProps {
  postType: keyof typeof PostTypes;
  pubName?: string;
}

const handlePostFormats = (postType: keyof typeof PostTypes) => {
  const postTypeObject: {[key: string]: string} = {
    instagramSquare: 'igSquare',
    instagramStory: 'igStory',
    instagramPortrait: 'igPortrait',
    pubTV: 'tv',
    facebookTimeline: 'fb',
  };

  return postTypeObject[postType];
};

export const namePostFile = ({postType, pubName}: IProps) => {
  const formattedType = handlePostFormats(postType);
  const formattedName = pubName?.split(' ').join('_');
  const formattedDate = moment().format('YYYY/MM/DD');

  return `${formattedType}${formattedName}_${formattedDate}`;
};
